.tableVariant {
  height: 100%;
}
